import { ReactElement } from 'react'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'

import ComprovanteTransferenciaImpl from '../../domain/usecases/ComprovanteTransferencia'
import GetCartoes from '../../domain/usecases/GetCartoes'
import TransferenciaRepository from '../../infra/repositories/TransferenciaRepository'
import VerifyPasswordImpl from '../../domain/usecases/VerifyPassword'
import PagamentoBoleto from '../../pages/PagamentoBoleto'
import EnviarPinTmovPayImpl from 'modules/pagamentos/domain/usecases/EnviarPinTmovPay'
import ValidarPinTmovPayImpl from 'modules/pagamentos/domain/usecases/ValidarPinTmovPay'

export const PagamentoBoletoFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const transferenciaRepository = new TransferenciaRepository()
  const comprovanteTransferenciaImpl = new ComprovanteTransferenciaImpl(
    transferenciaRepository,
  )
  const getCartao = new GetCartoes(pagamentoRepository)
  const verifyPassword = new VerifyPasswordImpl(pagamentoRepository)
  const enviarPinTmovPay = new EnviarPinTmovPayImpl(pagamentoRepository)
  const validarPinTmovPay = new ValidarPinTmovPayImpl(pagamentoRepository)

  return (
    <PagamentoBoleto
      verifyPassword={verifyPassword}
      enviarPinTmovPay={enviarPinTmovPay}
      validarPinTmovPay={validarPinTmovPay}
    />
  )
}

export default PagamentoBoletoFactory
